import type { StateCreator } from 'zustand'

import type { Project } from '../projects.type'

import type { ProjectsActionsSlice, ProjectsFetchPatch, ProjectsStore } from './projects.type'

type ProjectsSet = Parameters<StateCreator<ProjectsStore, [['zustand/immer', never]], [], ProjectsStore>>[0]

export const createProjectsSyncActions = (set: ProjectsSet): ProjectsActionsSlice => ({
  setState: (patch: ProjectsFetchPatch) => set((state) => ({ ...state, ...patch })),
  setProjects: (projects: Project[]) =>
    set((state) => {
      state.projects = projects
      for (const p of projects) {
        const i = state.allProjects.findIndex((x) => x.projectId === p.projectId)
        if (i >= 0) state.allProjects[i] = p
      }
    }),
  setCurrentProject: (project: Project | null) =>
    set((state) => {
      state.currentProject = project
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  invalidateProjectsCache: () =>
    set((state) => {
      state.allProjects = []
      state.userProjectsFetched = false
      state.projects = []
      state.currentProject = null
      state.loading = false
      state.error = null
    }),
  invalidateProjectsListCache: () =>
    set((state) => {
      state.allProjects = []
      state.userProjectsFetched = false
      state.projects = []
      state.loading = false
      state.error = null
    }),
})
